angular
    .module('MW.ContactManager.ContactManagerSourceService', [
        'Configuration',
        'MW.ContactManager.ContactManagerContactModel'
    ])
    .service('ContactManagerSourceService', [
        '$http',
        'CONTACT_MANAGER_SOURCE_URL',
        'CONTACT_MANAGER_CONTACT_URL',
        '$q',
        'Contact',
        function($http, CONTACT_MANAGER_SOURCE_URL, CONTACT_MANAGER_CONTACT_URL, $q, Contact) {
            'use strict';
            this.searchSources = function searchSources(query) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_SOURCE_URL + '/search', query).then(function(response) {
                    if (response.data.httpStatus && response.data.httpStatus !== 200) {
                        defer.reject(response.data);
                    }
                    else {
                        defer.resolve(response.data);
                    }
                }).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            this.getSourceById = function getSourceById(sourceId) {
                var defer = $q.defer();

                $http.get(CONTACT_MANAGER_SOURCE_URL + '/' + sourceId).then(function(response) {
                    defer.resolve(response.data);
                }).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            this.getSourcesByIds = function getSourcesByIds(sourceIds) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_SOURCE_URL + '/search/ids', sourceIds).then(function(response) {
                    defer.resolve(response.data.hits);
                }).catch(function(response){
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            this.getContactBasedOnSource = function getContactBasedOnSource(query) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/sources', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        });
                    }

                    defer.resolve(response.data);
                }).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };
        }
    ]);
